module.exports = __webpack_public_path__ + "static/media/consultant1.a720a54d.png";